import { render, staticRenderFns } from "./ai.vue?vue&type=template&id=364d783e"
import script from "./ai.vue?vue&type=script&lang=js"
export * from "./ai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports